// extracted by mini-css-extract-plugin
export default {"actions":"FirstRunDevicesTable_actions_BvII3"};